import type { AuditUpdateRequest } from '../../../../services/auditService';
import type { ActiveGamesAndPacksResponse } from '../../../../services/authService';
import { validateTicketDetailsAgainstActiveGamesAndPacks } from '../../../../utils/fixOcrDataProcessors';

type InvalidGame = { game: string | number; pack?: string | number; range?: string };
type InvalidPack = { game: string | number; pack: string | number; range?: string };

export const buildFixOcrFormStateKey = (
  formData: any,
  invalidGames: InvalidGame[],
  invalidPacks: InvalidPack[],
) => JSON.stringify({ formData, invalidGames, invalidPacks });

export const validateFixOcrFormState = (
  formData: any,
  activeGamesAndPacks: ActiveGamesAndPacksResponse,
) => {
  const validationResult = Array.isArray(formData?.ticket_details)
    ? validateTicketDetailsAgainstActiveGamesAndPacks(formData.ticket_details, activeGamesAndPacks)
    : {
        ticketDetails: formData?.ticket_details || [],
        invalidGames: [] as InvalidGame[],
        invalidPacks: [] as InvalidPack[],
      };

  const validatedFormData = {
    ...formData,
    ticket_details: validationResult.ticketDetails,
  };

  return {
    formData: validatedFormData,
    invalidGames: validationResult.invalidGames,
    invalidPacks: validationResult.invalidPacks,
    stateKey: buildFixOcrFormStateKey(
      validatedFormData,
      validationResult.invalidGames,
      validationResult.invalidPacks,
    ),
  };
};

export const buildFixOcrUpdateRequest = (data: any): AuditUpdateRequest => {
  if (data.shift_date && data.shift_start_time && data.shift_end_time) {
    let dateInMmDdYy = data.shift_date;
    if (data.shift_date && data.shift_date.includes('/')) {
      const [month, day, year] = data.shift_date.split('/');
      dateInMmDdYy = `${month}/${day}/${year}`;
    }

    return {
      action: data.action,
      notes: data.notes,
      confidence_score: Number(data.confidence_score),
      parsed_data: {
        final_json: {
          date: dateInMmDdYy,
          time: `${data.shift_start_time} TO ${data.shift_end_time}`,
          ticket_details: data.ticket_details,
          retailer: data.retailer_id,
        },
      },
    };
  }

  return {
    action: data.action,
    notes: data.notes,
    confidence_score: Number(data.confidence_score),
    parsed_data: data.parsed_data,
  };
};
